import { useUserData } from "../service/Hooks/useUserData";
import { useValidationStats } from '../service/Hooks/useValidationStats';


const ValidationStats = () => {
  const { accountId, selectedDomain } = useUserData();
  const domainId = selectedDomain?.id;

  const { stats, counts, urgent, loading, error } = useValidationStats(accountId, domainId);

  const statCards = [
    {
      title: "En Attente",
      value: counts?.pending || 0,
      icon: "fa fa-hourglass",
      color: "warning",
    },
    {
      title: "Approuvés",
      value: counts?.approved || 0,
      icon: "fa fa-check",
      color: "success",
      subtitle: stats?.approvalRateFormatted,
    },
    {
      title: "Rejetés",
      value: counts?.rejected || 0,
      icon: "fa fa-x",
      color: "danger",
    },
    {
      title: "Délai Moyen",
      value: stats?.averageProcessingTimeFormatted || "0 min",
      icon: "fa fa-clock",
      color: "info",
      subtitle: "Traitement moyen",
    },
  ];

  if (error) {
    return (
      <div className="alert alert-warning">
        <i className="bi bi-exclamation-triangle me-2"></i>
        {error}
      </div>
    );
  }

  return (
    <div className="row">
      {statCards.map((stat, index) => (
        <div key={index} className="col-xl-3 col-md-6 mb-0">
          <div
            className={`card border-0 shadow-sm border-start border-5 border-${stat.color}`}
          >
            <div className="card-body py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h6 className="text-muted fw-semibold mb-1">{stat.title}</h6>

                  {loading ? (
                    <div className="placeholder-glow">
                      <span className="placeholder col-4"></span>
                    </div>
                  ) : (
                    <>
                      <h4 className={`fw-bold text-${stat.color} mb-0`}>
                        {stat.value}
                      </h4>
                      {stat.subtitle && (
                        <small className="text-muted">{stat.subtitle}</small>
                      )}
                    </>
                  )}
                </div>

                <div
                  className={`flex-shrink-0 bg-${stat.color} bg-opacity-10 p-3 rounded`}
                >
                  {loading ? (
                    <div className="placeholder-glow">
                      <span
                        className="placeholder"
                        style={{ width: "24px", height: "24px" }}
                      ></span>
                    </div>
                  ) : (
                    <i className={`${stat.icon} text-${stat.color} fs-4`}></i>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationStats;
